module.exports = __webpack_public_path__ + "img/006.13b31b70.webp";